@let presence = summary();
<soft-ds-card
  class="abteilung-card"
  density="compact"
  [accent]="isSelected() ? 'primary' : 'none'"
  [chevron]="mode() === 'display' && !grid()"
  (click)="tapped.emit()"
  data-testid="abteilung-card"
>
  @if (grid()) {
    <div class="abteilung-card__tile">
      <ng-container *ngTemplateOutlet="chart; context: { size: 'w-25 h-25' }" />
      <div class="abteilung-card__text">
        <span class="ds-body-1-semibold">{{ abteilung().abteilung.bezeichnung }}</span>
        <span class="ds-body-2 text-light">
          <ng-container *ngTemplateOutlet="presenceText" />
        </span>
      </div>
      @if (isSelected()) {
        <soft-ds-icon name="fa-solid fa-circle-check" color="brand" size="lg" />
      }
    </div>
  } @else {
    <soft-ds-card-header>
      <soft-ds-card-leading align="center">
        <ng-container *ngTemplateOutlet="chart; context: { size: 'w-14 h-14' }" />
      </soft-ds-card-leading>
      <soft-ds-card-title>{{ abteilung().abteilung.bezeichnung }}</soft-ds-card-title>
      <soft-ds-card-description>
        <ng-container *ngTemplateOutlet="presenceText" />
      </soft-ds-card-description>
      @if (isSelected()) {
        <soft-ds-card-trailing align="center">
          <soft-ds-icon name="fa-solid fa-circle-check" color="brand" size="lg" />
        </soft-ds-card-trailing>
      }
    </soft-ds-card-header>
  }
</soft-ds-card>

<ng-template #chart let-size="size">
  @if (!presence.loaded) {
    <div class="flex items-center justify-center" [class]="size">
      <soft-ds-loading-spinner size="lg" />
    </div>
  } @else if (presence.total) {
    <soft-donut-chart [size]="size" [showTotal]="true" [segments]="segments()" />
  } @else {
    <div class="abteilung-card__ring" [class]="size"></div>
  }
</ng-template>

<ng-template #presenceText>
  @if (presence.loaded && !presence.total) {
    {{ '#PMS_STATUSABFRAGE.ABTEILUNGEN.KEINE_PERSONEN' | translate }}
  } @else {
    {{ presence.present }} von {{ presence.total }}
    {{ '#PMS_STATUSABFRAGE.ABTEILUNGEN.PERSONEN_ANWESEND' | translate }}
  }
</ng-template>
